import { Component, Input, Output, EventEmitter } from '@angular/core';

import { GoogleAccountVM } from 'src/app/models/google-account-vm';

@Component({
  selector: 'app-google',
  templateUrl: './google.component.html',
  styleUrls: ['./google.component.scss']
})
export class GoogleComponent {
  isMobile = false;

  ngOnInit() {
    this.isMobile = window.innerWidth <= 768;
  }

  @Input() googleAccounts: GoogleAccountVM[] = [];
  @Input() visible = false;
  @Input() loading = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() addGoogleAccount = new EventEmitter<void>();
  @Output() removeGoogleAccountEvent = new EventEmitter<GoogleAccountVM>();
  @Output() close = new EventEmitter<void>();

  onAddGoogleAccount(): void {
    this.addGoogleAccount.emit();
  }

  onRemoveGoogleAccount(account: GoogleAccountVM): void {
    this.removeGoogleAccountEvent.emit(account);
  }

  trackByUid = (_: number, a: GoogleAccountVM) => a.uid;
}
